import { ApiMenuItem } from '../types';

interface PermissionCheck {
  menuCode: string;
  permissionType: string;
}

const flattenMenus = (menus: ApiMenuItem[]): ApiMenuItem[] =>
  menus.flatMap(menu => [menu, ...(menu.children ? flattenMenus(menu.children) : [])]);

export const hasMenuPermission = (
  menus: ApiMenuItem[],
  permissions: string[],
  menuCode: string,
  permissionType: string,
) => {
  // 本地开发或后端未返回菜单时，保持页面可操作，真实权限由服务端兜底。
  if (menus.length === 0 && permissions.length === 0) {
    return true;
  }

  const menu = flattenMenus(menus).find(item => item.menuCode === menuCode);
  if (!menu) {
    return false;
  }

  const expected = `${menu.menuId}:${permissionType}`;
  return permissions.includes(expected) || menu.permissions.includes(expected) || menu.permissions.includes(permissionType);
};

export const hasAnyMenuPermission = (
  menus: ApiMenuItem[],
  permissions: string[],
  checks: PermissionCheck[],
) => checks.some(check => hasMenuPermission(menus, permissions, check.menuCode, check.permissionType));
